import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { Link } from 'react-router-dom';
import { Customer } from 'src/features/customers/utils/types';
import DeleteCustomerFormModal from 'src/features/customers/components/forms/DeleteCustomerFormModal';
import UpdateCustomerFormModal from 'src/features/customers/components/forms/UpdateCustomerFormModal';
import { customersMessages } from 'src/features/customers/utils/messages';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

export default function CellCustomersActions({ row }: CellContext<Customer, unknown>) {
    const { formatMessage } = useIntl();
    const permissionManageCustomers = useHasPermissions([PERMISSION.MANAGE_CUSTOMERS]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/customers/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
                {permissionManageCustomers && (
                    <>
                        <Tooltip>
                            <UpdateCustomerFormModal
                                semantics={{ entryName: formatMessage(customersMessages.customer).toLowerCase() }}
                                selectedCustomer={row.original}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateCustomerFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteCustomerFormModal selectedCustomer={row.original}>
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteCustomerFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
